import { render, staticRenderFns } from "./ProrrogacaoDeConta.vue?vue&type=template&id=428d3d39&scoped=true&"
import script from "./ProrrogacaoDeConta.vue?vue&type=script&lang=js&"
export * from "./ProrrogacaoDeConta.vue?vue&type=script&lang=js&"
import style0 from "./ProrrogacaoDeConta.vue?vue&type=style&index=0&id=428d3d39&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "428d3d39",
  null
  
)

export default component.exports